<!-- 水印类型选择 -->
<template>
  <div class="tips-block">
    <div class="flex-box">
      <div class="flex-1 fb-700">加水印（时间地点）</div>
      <el-switch
        :value="modelValue"
        @change="switchHandle"
        active-color="#1877FF"
        inactive-color="rgb(230, 230, 230)"
        :active-value="1"
        :inactive-value="0"
      />
    </div>
    <el-divider />
    <div class="flex-box" v-if="modelValue == 1">
      <el-checkbox-group v-model="checkList" @change="checkBoxHandle">
        <el-checkbox label="1">时间水印</el-checkbox>
        <el-checkbox label="2"> 地点位置水印</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaterMarkSwitch",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    watermarkTimeOrPosition: {
      type: String,
      default: "",
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        console.log("val", val);

        this.$emit("input", val);
      },
    },
    checkList: {
      get() {
        return this.watermarkTimeOrPosition
          ? this.watermarkTimeOrPosition.split(",")
          : [];
      },
      set(val) {
        this.$emit("update:watermarkTimeOrPosition", val.join(","));
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    switchHandle(val) {
      this.modelValue = val;
    },
    checkBoxHandle(val) {
      this.checkList = val;
    },
  },
};
</script>

<style scoped lang="scss">
.tips-block {
  margin-top: 10px;
  background-color: red;
  padding: 10px 0;
}
.flex-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: #fff;
}
.flex-1 {
  flex: 1;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0;
}

.fb-700 {
  font-weight: 700;
}
label {
  margin-bottom: 0;
}
</style>
